import { lightType } from '../helpers/enums';

 export const lightOptions = [];
lightOptions[lightType.Bench] =
{
    localizationString: "benchLight",
    id: lightType.Bench,
    benchLight: true,
    roofLight: false,
    stoveLight: false,
    linearLight: false,
    thumbnail: "img/light/benchlight.jpg"
};

lightOptions[lightType.Linear] =
{
    localizationString: "linearLight",
    id: lightType.Linear,
    benchLight: false,
    roofLight: false,
    stoveLight: false,
    linearLight: true,
    thumbnail: "img/light/linear.jpg"
};

lightOptions[lightType.BenchWithStove] =
{
    localizationString: "benchLigthWithStoveLight",
    id: lightType.BenchWithStove,
    benchLight: true,
    roofLight: false,
    stoveLight: true,
    linearLight: false,
    thumbnail: "img/light/benchlightwithstovelight.jpg"
};

lightOptions[lightType.RoofWithStove] =
{
    localizationString: "roofLigthWithBenchLight",
    id: lightType.RoofWithStove,
    benchLight: false,
    roofLight: true,
    stoveLight: true,
    linearLight: false,
    thumbnail: "img/light/stoveWithRoofLight.jpg"
};

lightOptions[lightType.LinearWithStove] =
{
    localizationString: "linearBarWithStoveLight",
    id: lightType.LinearWithStove,
    benchLight: false,
    roofLight: false,
    stoveLight: true,
    linearLight: true,
    thumbnail: "img/light/linear.jpg"
};

lightOptions[lightType.NoLigthing] =
{
    localizationString: "ownLighs",
    id: lightType.NoLigthing,
    benchLight: false,
    roofLight: false,
    stoveLight: false,
    linearLight: false,
    thumbnail: "img/light/nolight.jpg"
};
let allLights = [
    lightOptions[lightType.Bench],
    lightOptions[lightType.BenchWithStove],
    lightOptions[lightType.Linear],
    lightOptions[lightType.LinearWithStove],
    lightOptions[lightType.RoofWithStove],
    lightOptions[lightType.NoLigthing]]; 


var initialState =
{
    selectedLight: lightOptions[lightType.Bench],
    fibers: 10,
    allowNoLightSelection: true,
    avalaibleLights: allLights
}
const saunaLightning = (state = initialState, action) => {
    switch (action.type) {
        case 'LIGHTING_CHANGED':
            return Object.assign({}, state, {
                selectedLight: lightOptions[action.selectedLight]
            });
        case 'PLAN_LOADED':
            let ligthing = parseLightning(action.plan.LightningType);
            return Object.assign({}, state, ligthing);
        case 'PRODUCTS_CHANGED':
            let avalaibleLights = action.products.hasBench ? state.avalaibleLights : allLights;
            return Object.assign({}, state, {
                avalaibleLights: avalaibleLights
            })
        case 'AVAILABLE_LIGHTS_CHANGED':          
            let availableLights = action.avalaibleLights; 
            return Object.assign({}, state, {
                avalaibleLights: availableLights
            });
        case 'BENCH_CHANGED':
            return Object.assign({}, state, {
                fibers: action.bench.shape.numberOfBenchLightFibersNeeded,
            });
        default:
            return state;
    }
}
export default saunaLightning

/*let filterAvalaibleLightsBasedOnBench = (state, bench) => {
    let result = []
    result.push(lightOptions[lightType.Bench]);
    result.push(lightOptions[lightType.BenchWithStove]);
    if (!bench || bench.model.supportsLinearLed ) {
        result.push(lightOptions[lightType.Linear]);
        result.push(lightOptions[lightType.LinearWithStove]);
    }
    result.push(lightOptions[lightType.RoofWithStove]);
    if (state.allowNoLightSelection)
        result.push(lightOptions[lightType.NoLigthing]);
    return result;
}*/







let parseLightning = (input) => {
    if (input) {
        let parts = input.split(";");
        return{
                selectedLight:lightOptions[parts[0]],
                fibers: parseInt(parts[1])
        };
    }
    else {
        return
        {
            selectedLight: lightOptions[lightType.NoLigthing];
        }
    }
}


